import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function BurgerMenuIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g fill="none">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M3.00142 17.0761H21M3.00139 11.3821H21M3 6H20.9986"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
